import { AuthService } from '@uw/core/services/auth.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, NgForm, Validators, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router } from '@angular/router';
import { MenuService } from '@uw/themes/services/menu.service';
import { Subject } from 'rxjs';
import { CampaignStateService } from '@uw/core/services/campaign-state.service';
import { environment } from '@uw-env/environment';
import { AlertService } from '@uw/core/services/alert.service';
import { AlertPageType} from '@uw/core/enums/alert-pagetype.enum';
import { Alert } from '@uw/core/models/alert.model';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { customEmailValidator } from '@uw/shared/validators/custom-email-validator';
import { MatInput, MatError } from '@angular/material/input';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { MatButton } from '@angular/material/button';
import { UwRouterLink } from '../../../../shared/directives/directives/uw-router-link.directive';
import { LanguageSelectorComponent } from '../../../../shared/components/language-selector/language-selector.component';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
    selector: 'app-login-form',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    imports: [ReactiveFormsModule, MatInput, MatError, ButtonComponent, MatButton, UwRouterLink, LanguageSelectorComponent, TranslateModule]
})
export class LoginPageComponent implements OnInit, OnDestroy {

  loginFormGrp!: UntypedFormGroup;
  matcher = new MyErrorStateMatcher();
  errorMessage!: string;
  buttonLoading = false;
  destroy$ = new Subject();
  campaignGuid: string;
  alerts: Alert[] = [];

  readonly currentLanguage = this.translateService.currentLang;

  constructor(private fb: UntypedFormBuilder,
    private authService: AuthService,
    private readonly translateService: TranslateService,
    private router: Router,
    private menuService: MenuService,
    private alertService: AlertService,
    private campaignStateService: CampaignStateService,
  ) {
    // this.menuService.showDonarSubMenu(true);
    this.createForm();
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.campaignGuid = this.campaignStateService.getSelectedCampaign()?.campaignGuid ?? '';
    this.alertService.fetchAlerts(AlertPageType.LOGIN).subscribe(
      alerts => {
        this.alerts = alerts;
      },
      _error => {
        this.alerts = [];
      }
    );
  }


  createForm() {
    if (environment.mode !== 'dev') {
      this.loginFormGrp = this.fb.group({
        username: [null,[Validators.required, customEmailValidator()]],
        password: [null,[Validators.required]]
      });
    } else {
      this.loginFormGrp = this.fb.group({
        username: ['',[Validators.required, customEmailValidator()]],
        password: ['',[Validators.required]]
      });
    }
  }

  onNoClick(): void {
    //this.dialogRef.close();
  }

  login(): void {
    this.errorMessage = '';
    this.buttonLoading = true;
    this.authService.authenticateUser(this.loginFormGrp.value).subscribe(data => {
      if (data) {
        this.buttonLoading = true;

        this.redirect();
      }
    }, err => {
      this.buttonLoading = false;

      this.errorMessage = this.translateService.instant('login.failed_msg');
    });

  }


  async redirect(){
    this.menuService.showDonarSubMenu(false);
    this.buttonLoading = false;
  }

  showPassword(passwordControl: HTMLInputElement) {
    if (passwordControl.type === "password") {
      passwordControl.type = "text";
    } else {
      passwordControl.type = "password";
    }
  }

}
